import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  ${p => p.background && `background: ${p.background}`}
`